export enum SubjectLevel{
  master = 'master',
  subset = 'subset'
}
